import {useEffect, useRef} from 'react';

import {
  ErrorScreen,
  LoadingScreen,
  useAppError,
  useConfig,
  useConversation,
  useConversationExceptions,
  useConversationInlineDataEvents,
  useCurrentConversation,
} from '@stripe-internal/conversations-assistant';

import {MobileConversationScreen} from './MobileConversationScreen';

export function MobileAssistantScreen() {
  const loadingRef = useRef<boolean>(false);

  const appError = useAppError();
  const config = useConfig();

  const currentConversation = useCurrentConversation();
  const {resumeOrStartConversation, error} = useConversation();

  useConversationExceptions(currentConversation);
  useConversationInlineDataEvents(currentConversation);

  useEffect(() => {
    if (currentConversation) {
      loadingRef.current = false;
      return;
    }

    if (loadingRef.current) {
      return;
    }

    loadingRef.current = true;
    try {
      resumeOrStartConversation().then(() => {
        loadingRef.current = false;
      });
    } catch (e) {
      loadingRef.current = false;
    }
  }, [currentConversation, resumeOrStartConversation]);

  if (appError || error) {
    return <ErrorScreen config={config} error={appError ?? error} />;
  }

  if (loadingRef.current || !currentConversation) {
    return <LoadingScreen />;
  }

  return <MobileConversationScreen conversation={currentConversation} />;
}
